import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=7e79ea3c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=7e79ea3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e79ea3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e79ea3c')) {
      api.createRecord('7e79ea3c', component.options)
    } else {
      api.reload('7e79ea3c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=7e79ea3c&scoped=true&", function () {
      api.rerender('7e79ea3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N1MH9vbiKSII/JS/comp/GuestBox.vue"
export default component.exports